export default __webpack_public_path__ + "static/portfolio-profile-default-50b7acd7a5f672305392bffc55eed651.jpg";